import FieldWrapper from '@mfe-presentation/components/Wrappers/FieldWrapper';
import { useAppContext } from '@mfe-presentation/contexts';
import LegalText from '@mfe-presentation/components/LegalText';
// import SaleMethodMessage from '@mfe-presentation/components/SaleMethodMessage';

const Profile = () => {
    const { config, formValues } = useAppContext();
    const fields = config.profile.getFields(formValues);

    return (
        <>
            {Object.entries(fields).map(
                ([name, field]) =>
                    name !== 'saleMethod' && <FieldWrapper key={name} name={name} field={field} />,
            )}
            <LegalText />
            {/* The test on field sale method is paused */}
            {/* {fields.saleMethod && <FieldWrapper name="saleMethod" field={fields.saleMethod} />} */}
            {/* <SaleMethodMessage /> */}
        </>
    );
};

export default Profile;
